import styled, { css } from "styled-components";
import WvIconLoader from "../../../images/beacon-circle-orange.svg";
import loaderBg from "../../../images/loader-bg.jpg"; 
const commonLoaderStyles = css`
  width: 100vw;
  height: 100%;
  position: ${({position}) => position? position:"relative"};
  top: 0;
  left: 0;
  overflow:hidden;
  text-align: center;
  z-index: 12;

  ${(props) =>
    props.fulldiv &&
    `
    height: 100vh;
    width: 100vw;
  `}

  .spinner--wv-star {
    width: 60px;
    height: 60px;
    position: relative;
    transform: translateZ(0);
    margin: 0 auto;
    left: 0;
    right: 0;
    top: calc(50% - 30px);
    z-index:10;
  }

  .spinner--wv-star .double-bounce1,
  .spinner--wv-star .double-bounce2 {
    width: 100%;
    height: 100%;
    border-radius: 100%;
    background-color: #ff6b00;
    opacity: 0.8;
    position: absolute;
    top: 0;
    left: 0;
    animation: sk-bounce 2.5s infinite ease-in-out;
  }

  .spinner--wv-star .double-bounce2 {
    animation-delay: -2.5s / 2;
    background-image: url(${WvIconLoader});
    background-size: 60px 60px;
    background-repeat: no-repeat;
  }
  @-webkit-keyframes sk-bounce {
    0%,
    100% {
      -webkit-transform: scale(1);
    }
    50% {
      -webkit-transform: scale(0);
    }
  }
  @keyframes sk-bounce {
    0%,
    100% {
      transform: scale(1);
      -webkit-transform: scale(1);
    }
    50% {
      transform: scale(0);
      -webkit-transform: scale(0);
    }
  }

  .loader {
    color: #F66700;
    font-size: 10px;
    width: 1em;
    height: 1em;
    border-radius: 50%;
    position: absolute;
    text-indent: -9999em;
    animation: mulShdSpin 1.3s infinite linear;
    transform: translateZ(0);
    margin: 0 auto;
    left: 0;
    right: 0;
    top:50%
  }
  .loader_text {
    color: #FFF;
    font-family: "Lato-Bold";
    font-size: 22px;
    font-style: normal;
    line-height: 120%;
    width: auto;
    height: 100vh;
    border-radius: 50%;
    position: absolute;
    margin: 0 auto;
    left: 0;
    right: 0;
    top:58%;
    z-index:inherit;
  }
`

export const PageLoader = styled.div`
  ${commonLoaderStyles}
  background: rgba(0, 0, 0, 0.5);
`;

export const PageLoaderNew = styled.div`
  ${commonLoaderStyles}
  background-image: url(${loaderBg});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: inherit;
    background-size: inherit;
    background-repeat: inherit;
    background-position: inherit;
    filter: blur(7px) brightness(0.6);
    z-index: -1;
  }
`;